module.exports = __webpack_public_path__ + "img/cta-mind-fr.0355a8f6.png";